import React from 'react'
import Germantown from '../components/Germantown.jsx'

const GermantownPage = () => {

return(
    <Germantown/>
)
}

export default GermantownPage